import { Key } from '../items/Key';
import { RawMeat } from '../items/RawMeat';
import { IMob } from './IMob';
export class Bear extends IMob {
    constructor(context) {
        super(context);
        this.health = 150;
    }
    /**
     *
     * @return {number}
     */
    getStrength() {
        if (this.health < 50 && this.context.getRandom().nextBoolean()) {
            this.context
                .getView()
                .console()
                .println$java_lang_String('Der B\u00e4r ist rasend vor Wut.');
            return 30;
        }
        return 16;
    }
    /**
     *
     * @return {number}
     */
    getHealth() {
        return this.health;
    }
    /**
     *
     * @param {number} health
     */
    setHealth(health) {
        this.health = health;
    }
    /**
     *
     * @return {IItem}
     */
    getDrop() {
        const n = this.context.getRandom().nextInt(100);
        if (n < 20) {
            return new Key(this.context);
        }
        return new RawMeat(this.context);
    }
    /**
     *
     * @return {number}
     */
    getExperience() {
        return 600;
    }
    /**
     *
     */
    onBeaten() { }
    /**
     *
     * @return {string}
     */
    getDisplayName() {
        return 'B\u00e4r';
    }
    /**
     *
     */
    onUseFromWorld() {
        this.context.getView().mobInspection(this);
    }
    /**
     *
     * @return {string}
     */
    getGender() {
        return 'm';
    }
}
Bear['__class'] = 'de.coco.mindLinq.world.mobs.Bear';
